import React from "react";
import Logo from "./priceTracker/Logo";
import Coin from "./priceTracker/Coin";
import Footer from "./priceTracker/Footer";

function App() {
  return (
    <div className="App">
      <Logo />
      <Coin />  
      <Footer />
    </div>
  );
}

export default App;
